// extracted by mini-css-extract-plugin
module.exports = {"Home":"Zonic_Home__14Ibt","Content":"Zonic_Content__yZaI8","Info":"Zonic_Info__1mUVf","BottomBar":"Zonic_BottomBar__3NHAz"};